var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDangerCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C4.47 20 0 15.53 0 10S4.47 0 10 0s10 4.47 10 10-4.47 10-10 10zm0-18.824c-4.824 0-8.824 4-8.824 8.824 0 4.823 4 8.823 8.824 8.823 4.823 0 8.823-4 8.823-8.823 0-4.824-4-8.824-8.823-8.824z",
    fill: "#F65B51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.967 12.453a.976.976 0 00-.967.985c0 .543.433.984.967.984s.967-.44.967-.985a.976.976 0 00-.967-.984zM9.57 5h.794c.236 0 .424.2.414.44l-.242 5.906a.418.418 0 01-.414.404h-.31a.418.418 0 01-.414-.404l-.242-5.907A.419.419 0 019.57 5zm.397 7.453a.976.976 0 00-.967.985c0 .543.433.984.967.984s.967-.44.967-.985a.976.976 0 00-.967-.984z",
    fill: "#F65B51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerCircle);
export default __webpack_public_path__ + "static/media/danger-circle.57779a821840deb1d62cb54ab7e93ec5.svg";
export { ForwardRef as ReactComponent };